export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

export * from './api';
export * from './DocumentTypes';
export * as ERRORS from './errors';
export * as ENV from './env';
export * from './Languages';
export * from './MedicalDocuments';
export * from './ProcessTypes';
